import React from 'react';
import { get } from 'lodash';
import { Text, Link, Icon } from '@upsales/components';
import TimelineRow from 'Components/TimelineRow';
import { openEditAppointment } from 'Components/Modals/Appointment/EditAppointment';
import { getContactCardHref } from 'App/helpers/contactCardNavigation';
import T from 'Components/Helpers/translate';

const ActivityTimelineBookAppointment = ({ options = {}, event, hideIcon }) => {
	const lang = {
		bookedAppointment: T('activity.outcomeLog.bookedAppointment'),
		with: T('activity.outcomeLog.with'),
		closedThisActivity: T('activity.outcomeLog.closedThisActivity')
	};
	const { user, data } = event || {};
	const contactName = get(data, 'contact.name', '');
	const contactId = get(data, 'contact.id', '');
	const appointmentId = get(data, 'appointment.id', '');
	const appointmentName = get(data, 'appointment.description', '');
	const openAppointment = () => {
		openEditAppointment({ id: appointmentId });
	};
	const date = get(event.data, 'closeDate');
	const userName = get(user, 'name');

	const title = (
		<Text>
			{`${lang.bookedAppointment} `}
			<Link onClick={openAppointment}>{appointmentName}</Link>
			{` ${lang.with} `}
			<Link onClick={e => e.stopPropagation()} href={getContactCardHref(contactId)}>
				{contactName}
			</Link>
		</Text>
	);
	const subTitle = date ? (
		<Text size="sm" color="grey-11">
			{moment(date).format('L LT')} <span dangerouslySetInnerHTML={{ __html: '&#8226;' }} /> {userName}
		</Text>
	) : null;
	const subSection = (
		<Text className="subSection">
			<Icon name="check" space="mrl" color="black" />
			{lang.closedThisActivity}
		</Text>
	);

	return (
		<TimelineRow
			icon={hideIcon ? undefined : 'calendar'}
			options={options}
			event={event}
			title={title}
			subTitle={subTitle}
			subSection={subSection}
		/>
	);
};

export default ActivityTimelineBookAppointment;
